import React from "react";
import {FormattedMessage} from "react-intl";
import VolumeCounter from "./VolumeCounter";
import TestimonialsAvatars from "./TestimonialsAvatars";
import {useNavigate} from "react-router-dom";

// Marketing hero modelled on the sepaheld.com landing page: live debit-volume
// counter, serif headline with a muted sub-headline, a short value-proposition
// paragraph and avatar/stars social proof. Shown to customers on the auth pages
// (login, register) and the provider callback, who may not know SepaHeld yet.
const SepaHeldHero = () => {

    const outlineButtonClasses = 'inline-flex w-full items-center justify-center rounded-2xl border border-indigo-200 bg-white px-5 py-3 text-sm font-semibold text-indigo-600 transition hover:border-indigo-300 hover:bg-indigo-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-100 sm:w-auto';
    const navigate = useNavigate();

    return (
        <div className="flex max-w-2xl flex-col items-start gap-6 text-left">
            <VolumeCounter/>

            <h1 className="font-serif text-4xl font-black leading-[1.05] tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
                <FormattedMessage
                    id="sepaheld.hero.headline"
                    defaultMessage="Collect SEPA direct debits automatically"
                />
                <span
                    className="mt-3 block text-2xl font-semibold leading-tight text-slate-400 sm:text-3xl lg:text-[2.25rem]">
                <FormattedMessage
                    id="sepaheld.hero.subheadline"
                    defaultMessage="straight from your ERP & accounting system"
                />
            </span>
            </h1>

            <p className="max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
                <FormattedMessage
                    id="sepaheld.hero.body"
                    defaultMessage="SepaHeld makes direct debits easy: digital mandates, seamless transfer and automated booking suggestions — without dunning effort and without manual work."
                />
            </p>

            <div className="flex flex-row gap-3 mb-8">
                <button
                    type="button"
                    onClick={() => navigate("https://sepaheld.com/")}
                    className="inline-flex w-full items-center justify-center rounded-2xl bg-indigo-600 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-200 sm:w-auto"
                >
                    Mehr erfahren
                </button>
                <button
                    type="button"
                    onClick={() => navigate("https://sepaheld.com/#demo")}
                    className={outlineButtonClasses}
                > Demo ansehen
                </button>
            </div>

            <TestimonialsAvatars/>
        </div>
    )
};

export default SepaHeldHero;
